import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'

const SCAN_LOGS_URL = `${backend}/api/pvz/data/scan/logs`
const HISTORY_URL = `${backend}/api/pvz/data/parcels/history`
const BALANCES_URL = `${backend}/api/pvz/data/balances`

// Strip empty / null / undefined values so we only send active filters.
const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    )
  )

export const fetchPvzScanLogs = createAsyncThunk(
  'pvz/fetchScanLogs',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(SCAN_LOGS_URL, {
        params: cleanParams(params),
      })
      return data
    } catch (error) {
      return rejectWithValue(error?.messageRu || error?.message || 'error')
    }
  }
)

export const fetchPvzParcelHistory = createAsyncThunk(
  'pvz/fetchParcelHistory',
  async (params, { rejectWithValue }) => {
    const clean = cleanParams(params)
    try {
      const { data } = await axios.get(HISTORY_URL, { params: clean })
      return data
    } catch (firstError) {
      // Retry once (2 requests max) before giving up.
      try {
        const { data } = await axios.get(HISTORY_URL, { params: clean })
        return data
      } catch (error) {
        return rejectWithValue(error?.messageRu || error?.message || 'error')
      }
    }
  }
)

export const fetchPvzBalances = createAsyncThunk(
  'pvz/fetchBalances',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(BALANCES_URL, {
        params: cleanParams(params),
      })
      return data
    } catch (error) {
      return rejectWithValue(error?.messageRu || error?.message || 'error')
    }
  }
)
